import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { EntityService } from "@/service/EntityService";
const initialState = {
    loading: false,
    entity: [],
    entityById: [],
    selectedEntity: {},
};
const action = {
    create: createAsyncThunk("entity/create", async (payload, thunkAPI) => {
        return (await EntityService.create(thunkAPI, payload.data)).data;
    }),
    readByEntityApplicationId: createAsyncThunk("entity/readByEntityApplicationId", async (payload, thunkAPI) => {
        return (await EntityService.readByEntityApplicationId(thunkAPI, payload)).data;
    }),
    update: createAsyncThunk("entity/update", async (payload, thunkAPI) => {
        return (await EntityService.update(thunkAPI, payload.data)).data;
    }),
    bulkCreate: createAsyncThunk("entity/bulkCreate", async (payload, thunkAPI) => {
        return (await EntityService.bulkCreate(thunkAPI, payload.data)).data;
    }),
    read: createAsyncThunk("entity/read", async (_, thunkAPI) => {
        return (await EntityService.read(thunkAPI)).data;
    }),
    delete: createAsyncThunk("entity/delete", async (payload, thunkAPI) => {
        return (await EntityService.delete(thunkAPI, payload.data)).data;
    })
};
const slice = createSlice({
    name: "entity",
    initialState,
    reducers: {
        setLoading(state, { payload }) {
            state.loading = payload;
        },
        setSelectedEntity(state, { payload }) {
            state.selectedEntity = payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(action.create.pending, (state) => {
            state.loading = true;
        })
            .addCase(action.create.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00")
                action.meta.arg.onSuccess?.(action.payload);
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.readByEntityApplicationId.pending, (state) => {
            state.loading = true;
        }).addCase(action.readByEntityApplicationId.fulfilled, (state, action) => {
            state.loading = false;
            const response = action.payload;
            if (response.responseCode === "00") {
                state.entityById = response.data;
            }
        }).addCase(action.update.pending, (state) => {
            state.loading = true;
        }).addCase(action.update.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        }).addCase(action.delete.pending, (state) => {
            state.loading = true;
        }).addCase(action.delete.fulfilled, (state, action) => {
            const response = action.payload;
            state.loading = false;
            if (response.responseCode === "00") {
                action.meta.arg.onSuccess?.(action.payload);
            }
            else {
                action.meta.arg.onError?.(action.payload);
            }
        })
            //     .addCase(action.bulkCreate.pending, (state) => {
            //     state.loading = true
            // }).addCase(action.bulkCreate.fulfilled, (state, action) => {
            //     const response = action.payload as BaseResponse;
            //     state.loading = false
            //     if (response.responseCode === "00") {
            //         action.meta.arg.onSuccess?.(action.payload)
            //     } else {
            //         action.meta.arg.onError?.(action.payload);
            //     }
            // })
            .addCase(action.read.pending, (state) => {
            state.loading = true;
        }).addCase(action.read.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload.responseCode === "00")
                state.entity = action.payload.data;
        });
    },
});
export const entity = {
    reducer: slice.reducer,
    action: action,
    mutation: slice.actions,
};
